import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AuthState from '@packages/contexts/auth/authState';
import StyledApp from './App.styles';

import AppRoutes from './components/Application/AppRoutes';

const App: React.FC = (): React.ReactElement => {
    return (
        <StyledApp>
            <AuthState>
                <Router>
                    <AppRoutes />
                </Router>
            </AuthState>
        </StyledApp>
    );
};

export default App;
